export enum adminRecruitmentCopyTypes {
    FETCH_ADMIN_RECRUITMENT_COPY_REQUEST = "FETCH_ADMIN_RECRUITMENT_COPY_REQUEST",
    FETCH_ADMIN_RECRUITMENT_COPY_SUCCESS = "FETCH_ADMIN_RECRUITMENT_COPY_SUCCESS",
    FETCH_ADMIN_RECRUITMENT_COPY_FAILURE = "FETCH_ADMIN_RECRUITMENT_COPY_FAILURE",
  }